export default "__VITE_ASSET__db307263__"